<template>
  <router-view />
</template>

<script>
export default {
  name: 'CoursesIndex'
}
</script>
